<div class="container inv-onboarding">
  <header class="row">
    <div class="col-8 col-sm-8 col-md-4">
      <h1>Investec</h1>
      <img alt="Investec logo" class="investec-logo" src="../assets/images/Investec.svg" title="Investec"/>
    </div>
    <div class="col-4 col-sm-4 col-md-8">
      <div *ngIf="hasLoginCapability() && isLoggedIn" class="phone-section float-end">
        <ui-button (click)="logout()">Logout</ui-button>
      </div>
      <div *ngIf="showPhoneNumbers()" class="phone-section float-end">
        <ui-icon *ngIf="formType !== null" [color]="'teal'" [name]="'help-and-support-call-default'" [size]="'48'"
                 class="large-icon"></ui-icon>
        <div *ngIf="formType === QueryFormType.UKVOY" class="text-container">
          <p class="lead text-info-emphasis">0330 123 4512</p>
          <p class="medium">+44 207 597 4050</p>
        </div>
        <div *ngIf="formType === QueryFormType.UKPBA" class="text-container">
          <p class="lead text-info-emphasis">0330 123 1966</p>
          <p class="medium">+44 207 597 4044</p>
        </div>
        <div *ngIf="formType === QueryFormType.UKCAA" class="text-container">
          <p class="lead text-info-emphasis">0330 123 3655</p>
          <p class="medium">+44 207 597 4131</p>
        </div>
      </div>
      <div (click)="handleMenuClick()" *ngIf="formStart" class="menu-button-section {{menuOpen ? 'open' : 'closed' }}">
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
      </div>
    </div>
  </header>
  <div *ngIf="IE">
    <ui-alerts [alertName]="'warning'" [heading]="'Sorry, we no longer support Internet Explorer'"
               [message]="'Please switch to a supported browser to access this page.'"></ui-alerts>
  </div>
  <div *ngIf="!IE" class="main-container">
    <router-outlet></router-outlet>
  </div>
  <app-session-modal (extendSessionCallback)="extendSession()" (sessionEnding)="sessionEnding()"
                     [screenChanged]="screenChanged"
                     [timeInSeconds]="timeout"></app-session-modal>
</div>
